import UserComponent from '../components/UsersPage'

const Users = () => {
  return (
    <>   
    <UserComponent/>
    </>
  )
}

export default Users